export default __webpack_public_path__ + "static/media/BenefitsMobile.1cd0a792.png";